<style lang="scss">
.student-ou-structure {
	.el-form-item {
		margin-bottom: 0;
	}
	&:empty {
		display: none;
	}
	&__row {
		@include flex;
		margin-bottom: 10px;
	}
	&__col {
		width: 65px;
		padding-right: 20px;
		&:last-child {
			padding-right: 0;
		}
		&.radios {
			width: 100%;
		}
	}
	&__level {
		border-radius: 50%;
		border: 1px solid #909399;
		border-radius: 50%;
		height: 25px;
		width: 25px;
		line-height: 25px;
		margin-top: 6px;
		text-align: center;
		font-size: 12px;
		color: #909399;
	}
	& ::v-deep &__preview {
		padding-left: 20px;
	}
}
</style>

<template lang="pug">
	.student-ou-structure
		el-form(:inline="true")
		el-form-item(label="OU structure")
		template
			.student-ou-structure__row(v-for="(selectedPart, index) in selectedParts")
				.student-ou-structure__col
					.student-ou-structure__level {{ index + 1 }}
				.student-ou-structure__col.radios
					el-radio-group(v-model="selectedPart.name")
						el-radio-button(v-for="availablePart in availableParts" :label="availablePart.name" :name="availablePart.name" :disabled="alreadyUsed(selectedPart, availablePart)") {{ availablePart.label }}
				.student-ou-structure__col
					el-button(type="danger", @click="remove(index)", icon="fe fe-trash-2 fe-no-margin", plain="")
			el-button(:disabled="!moreAvailable" icon="fe fe-plus fe-just-off" @click="add" type="text") Add level
			el-popover(trigger="click" placement="right")
				el-button(:disabled="selectedParts.length === 0 || !ouCalcs || ouCalcs.length === 0" slot="reference" icon="fe fe-search fe-just-off" type="text" class="student-ou-structure__preview") Show preview
				el-tree(:data="ouCalcs")
</template>

<script>
import _ from "lodash";
import gql from "graphql-tag";
export default {
	props: {
		value: { type: Array, default: () => [] }
	},

	data() {
		return {
			availableParts: [
				{ name: "phase", label: "Phase of Education" },
				{ name: "key_stage", label: "Key Stage" },
				{ name: "year", label: "Year" },
				{ name: "house", label: "House" },
				{ name: "registration", label: "Registration Group" }
			],
			selectedParts: _.map(this.value, part => ({ name: part }))
		};
	},

	watch: {
		selectedParts: {
			handler: function() {
				this.$emit("input", _.map(this.selectedParts, "name"));
			},
			deep: true
		}
	},

	computed: {
		moreAvailable() {
			return this.selectedParts.length < this.availableParts.length;
		}
	},

	methods: {
		add() {
			this.selectedParts.push({});
		},

		remove(index) {
			this.selectedParts.splice(index, 1);
		},

		alreadyUsed(selected, current) {
			if (!selected || !current) return false;
			return selected.name != current.name && _.some(this.selectedParts, { name: current.name });
		}
	},

	apollo: {
		ouCalcs: {
			query: gql`
				query CalcOuPreview($structure: String) {
					OuCalcs(structure: $structure) {
						id
						parentId
						displayName
					}
				}
			`,
			variables() {
				return {
					structure: this && this.selectedParts ? _.map(this.selectedParts, "name").join(",") : null
				};
			},
			fetchPolicy: "network-only",
			update: r => {
				const ous = _.cloneDeep(r.OuCalcs);

				// Def recursive func to build child items
				const descend = outerOu => {
					const children = _.remove(ous, innerOu => innerOu.parentId === outerOu.id);
					if (children.length) outerOu.children = _.map(children, descend);

					return {
						label: outerOu.displayName,
						children: outerOu.children
					};
				};

				// Get root element(s) and build heirarchy for each
				const roots = _.remove(ous, ou => ou.parentId === null);
				return _.map(roots, descend);
			}
		}
	}
};
</script>

